/* Keep French navigation stable during Shopify's locale-route incident (2026-09-28). */
(()=>{
  'use strict';
  if(document.documentElement.lang.toLowerCase().split('-')[0]!=='fr')return;
  function frenchURL(value){
    if(typeof value!=='string')return value;
    const raw=value.trim();
    if(!raw||raw[0]==='#')return value;
    let url;try{url=new URL(raw,location.origin);}catch{return value;}
    if(url.origin!==location.origin||!/^\/en(?:\/|$)/.test(url.pathname))return value;
    url.pathname=url.pathname.replace(/^\/en(?=\/|$)/,'')||'/';
    return url.pathname+url.search+url.hash;
  }
  if(window.Shopify?.routes)window.Shopify.routes.root='/';
  if(window.routes)for(const key of Object.keys(window.routes))window.routes[key]=frenchURL(window.routes[key]);
  function normalize(element){
    if(element.matches('a[href]')){
      if(element.matches('[hreflang="en"],[lang="en"],[data-locale-switch]'))return;
      const before=element.getAttribute('href'),after=frenchURL(before);
      if(after!==before)element.setAttribute('href',after);
    }else if(element.matches('form[action]')){
      const before=element.getAttribute('action'),after=frenchURL(before);
      if(after!==before)element.setAttribute('action',after);
    }
  }
  function scan(root){
    if(root.nodeType===1)normalize(root);
    root.querySelectorAll?.('a[href],form[action]').forEach(normalize);
  }
  scan(document);
  new MutationObserver(records=>{
    for(const record of records){
      if(record.type==='attributes')normalize(record.target);
      else for(const node of record.addedNodes)scan(node);
    }
  }).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['href','action']});
  document.addEventListener('click',event=>{
    const link=event.target.closest?.('a[href]');if(link)normalize(link);
  },true);
})();

/* Locale-aware strings and routes for interactive theme components. */
(()=>{const english=document.documentElement.lang.toLowerCase().split('-')[0]==='en';window.CabaneI18n={english,pick:(fr,en)=>english?en:fr,url:value=>{const root=window.Shopify?.routes?.root||'/';if(typeof value!=='string'||!value.startsWith('/')||value.startsWith('//')||root==='/'||value.startsWith(root)||value===root.slice(0,-1))return value;return root.replace(/\/$/,'')+value;}};})();

(()=>{const labels={"Couleur :":"Colour:","Poids":"Weight","Poids total":"Total weight","Hauteur totale":"Overall height","Hauteur du guidon":"Handlebar height","Hauteur du guidon seul":"Handlebar height","Largeur du guidon":"Handlebar width","Matière du guidon":"Handlebar material","Diamètre interne du guidon":"Handlebar internal diameter","Diamètre externe du guidon":"Handlebar external diameter","Modèle de collier":"Clamp model","Type de compression":"Compression type","Type de compression fourche":"Fork compression type","Largeur du deck":"Deck width","Longueur du deck":"Deck length","Angle du tube de direction":"Headtube angle","Type et dimensions du jeu de direction":"Headset type and dimensions","Diamètre roue":"Wheel diameter","Diamètre des roues":"Wheel diameter","Largeur roue":"Wheel width","Niveau d’assemblage":"Assembly level","Inclus":"Included","Niveau du rider":"Rider level","Style de ride":"Riding style","Très facile":"Very easy","intégé":"Integrated","Intégré":"Integrated","Clé 6 mm":"6 mm Allen key","Non renseigné":"Not specified","Taille":"Size","Pointure":"Shoe size","Couleur":"Colour","Longueur":"Length","Largeur":"Width","Côté":"Hand","Gaucher":"Left-handed","Droitier":"Right-handed"};window.CabaneI18n.text=value=>window.CabaneI18n.english?(labels[value]||value):value;})();
